import { ajaxController } from "./controller/AjaxController";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { PersonnelDTO, PersonOptionDTO, SaveLicenceRequest, SavePersonnelRequest } from "../DTOs/DrillBlast/ExplosivesDTO";

class PersonnelAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/Personnel";

  public getPersonnel() {
    return this._ajaxController.get<PagedResult<PersonnelDTO>>(this._endpoint, {});
  }

  public getOptions(on?: string) {
    return this._ajaxController.get<PagedResult<PersonOptionDTO>>(`${this._endpoint}/options`, on ? { on } : {});
  }

  public addPerson(request: SavePersonnelRequest) {
    return this._ajaxController.post<SavePersonnelRequest, PersonnelDTO>(this._endpoint, request);
  }

  public updatePerson(personnelId: number, request: SavePersonnelRequest) {
    return this._ajaxController.put<SavePersonnelRequest, PersonnelDTO>(`${this._endpoint}/${personnelId}`, request);
  }

  public addLicence(personnelId: number, request: SaveLicenceRequest) {
    return this._ajaxController.post<SaveLicenceRequest, PersonnelDTO>(`${this._endpoint}/${personnelId}/licences`, request);
  }

  public updateLicence(licenceId: number, request: SaveLicenceRequest) {
    return this._ajaxController.put<SaveLicenceRequest, PersonnelDTO>(`${this._endpoint}/licences/${licenceId}`, request);
  }

  public deleteLicence(licenceId: number) {
    return this._ajaxController.delete<PersonnelDTO>(`${this._endpoint}/licences/${licenceId}`);
  }
}

export const personnelAjax = new PersonnelAjax();
